var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightPanel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.334 18.335c0-.346.28-.625.625-.625h5.757A2.708 2.708 0 0 0 17.424 15v-10a2.708 2.708 0 0 0-2.708-2.708H8.96a.625.625 0 1 1 0-1.25h5.757a3.958 3.958 0 0 1 3.958 3.958v10a3.958 3.958 0 0 1-3.958 3.959H8.96a.625.625 0 0 1-.625-.625z",
    fill: "#1E90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.008 18.335a.625.625 0 0 0-.625-.625H5.625A2.708 2.708 0 0 1 2.917 15v-10a2.708 2.708 0 0 1 2.708-2.708h5.758a.625.625 0 1 0 0-1.25H5.625a3.958 3.958 0 0 0-3.958 3.958v10a3.958 3.958 0 0 0 3.958 3.959h5.758c.345 0 .625-.28.625-.625zM13.334 1.668c.345 0 .625.28.625.625V17.71a.625.625 0 1 1-1.25 0V2.293c0-.345.28-.625.625-.625z",
    fill: "#1E90FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPanel);
export default __webpack_public_path__ + "static/media/rightPanel.26b1d3dc33d269e492f048c33a878a70.svg";
export { ForwardRef as ReactComponent };